import React from 'react'
import clsx from 'clsx'
import moment from 'moment'
import { IconButton, useTheme } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { ArrowLeft2, ArrowRight2 } from 'iconsax-react'

import useStyles from './styles'

const format = 'MMM Do'

const Calendar = ({
  children,
  anchorEl,
  showToolbar,
  birthday,
  disabled,
  value: rawValue,
  open,
  ...props
}) => {
  const theme = useTheme()

  const [isOpen, setIsOpen] = React.useState(false)

  const classes = useStyles({ disabled })

  const value = React.useMemo(() => {
    if (!rawValue) {
      return rawValue
    }

    return moment(rawValue)
  }, [rawValue])

  const renderDay = React.useCallback(
    (day, selectedDate, outsideCurrentMonth) => {
      const isSelected = selectedDate?._isAMomentObject
        ? day.format(format) === selectedDate.format(format)
        : false

      return (
        <IconButton
          className={clsx(
            classes.day,
            isSelected && classes.selected,
            outsideCurrentMonth && classes.faded,
            birthday && day >= new Date() && classes.faded
          )}
          size='large'
        >
          {day.format('D')}
        </IconButton>
      )
    },
    [classes.day, classes.selected, classes.faded, birthday]
  )

  return (
    <>
      <div
        onClick={() => {
          if (!disabled) {
            setIsOpen(true)
          }
        }}
        className={classes.children}
      >
        {children}
      </div>

      <DatePicker
        closeOnSelect
        value={value}
        onClose={() => setIsOpen(false)}
        slots={{
          field: () => null,
          leftArrowIcon: () => (
            <ArrowLeft2 size={theme.size.base} className={classes.icon} />
          ),
          rightArrowIcon: () => (
            <ArrowRight2 size={theme.size.base} className={classes.icon} />
          ),
          day: props => {
            const {
              day,
              outsideCurrentMonth,
              onBlur,
              onDaySelect,
              onFocus,
              onKeyDown
            } = props

            return (
              <div
                onBlur={e => onBlur(e, day)}
                onClick={() => {
                  onDaySelect(day)
                  setIsOpen(false)
                }}
                onFocus={e => onFocus(e, day)}
                onKeyDown={e => onKeyDown(e, day)}
              >
                {renderDay(day, value, outsideCurrentMonth)}
              </div>
            )
          }
        }}
        slotProps={{
          actionBar: { actions: ['cancel', 'today'] },
          popper: {
            anchorEl: anchorEl?.current ?? anchorEl
          },
          toolbar: {
            hidden: !showToolbar
          }
        }}
        format={format}
        maxDate={birthday ? new Date() : undefined} // cant set future day for birthday
        disabled={disabled}
        open={open || isOpen}
        {...props}
      />
    </>
  )
}

export default Calendar
